import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=f276e1b0&"
import script from "./VTable.vue?vue&type=script&lang=js&"
export * from "./VTable.vue?vue&type=script&lang=js&"
import style0 from "./VTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f276e1b0')) {
      api.createRecord('f276e1b0', component.options)
    } else {
      api.reload('f276e1b0', component.options)
    }
    module.hot.accept("./VTable.vue?vue&type=template&id=f276e1b0&", function () {
      api.rerender('f276e1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VTable.vue"
export default component.exports